import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "@/App";
import store from "@/store";
import { PostHogProvider } from "@posthog/react";

ReactDOM.createRoot(document.getElementById("root")).render(
    <PostHogProvider
        apiKey={import.meta.env.VITE_POSTHOG_PROJECT_TOKEN}
        options={{
            api_host: import.meta.env.VITE_POSTHOG_HOST,
            defaults: "2026-01-30",
        }}
    >
        <Provider store={store}>
            <App />
        </Provider>
    </PostHogProvider>,
);
